export const aboutData = {
  brandName: '妖精漫画',
  brandIntro: '妖精漫画成立于2022年，是国内领先的免费韩国漫画在线阅读平台。我们致力于为漫画爱好者提供最优质的阅读体验，以"免费、便捷、海量"为核心理念，打造一个属于所有漫画爱好者的线上漫画博物馆。',
  mission: '让每一个人都能自由享受漫画的乐趣，打破阅读门槛，构建最完整的韩国漫画资源库。',
  vision: '成为华语地区最受欢迎的韩国漫画阅读平台，推动韩漫文化在华语圈的传播与发展。',
  values: [
    { title: '免费开放', description: '坚持免费阅读模式，让优质漫画触手可及，不让价格成为享受漫画的障碍。', icon: 'ri-open-arm-line' },
    { title: '海量资源', description: '持续扩充漫画库，收录最全最新的韩国漫画作品，打造漫画爱好者的天堂。', icon: 'ri-database-2-line' },
    { title: '优质体验', description: '下拉式阅读设计，流畅的翻页体验，精心优化的阅读界面，让每一话都读得舒服。', icon: 'ri-thumb-up-line' },
    { title: '用户至上', description: '倾听用户声音，持续优化产品，以用户满意度为衡量成功的核心标准。', icon: 'ri-user-heart-line' },
  ],
  stats: [
    { label: '收录漫画', value: '3,200+', icon: 'ri-book-open-line' },
    { label: '累计章节', value: '156,000+', icon: 'ri-file-list-3-line' },
    { label: '月活用户', value: '580万+', icon: 'ri-user-line' },
    { label: '好评率', value: '98.5%', icon: 'ri-star-line' },
  ],
  timeline: [
    { year: '2022', title: '平台创立', description: '妖精漫画正式上线，首批收录500部热门韩国漫画。' },
    { year: '2023', title: '快速发展', description: '漫画库扩充至1500部，月活用户突破100万，推出下拉式阅读模式。' },
    { year: '2024', title: '行业领先', description: '漫画总量突破2500部，月活用户超300万，成为韩国漫画阅读领域头部平台。' },
    { year: '2025', title: '生态建设', description: '推出创作者扶持计划，与韩国多家漫画工作室达成合作，独家引进优质作品。' },
    { year: '2026', title: '持续进化', description: '漫画总量突破3200部，月活用户超580万，持续优化阅读体验与内容质量。' },
  ],
  reputations: [
    {
      name: '漫画迷小陈',
      avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20student%20avatar%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20cream%20background%2C%20simple%20digital%20illustration%20portrait&width=120&height=120&seq=avatar-01&orientation=squarish',
      rating: 5,
      comment: '妖精漫画真的是我见过最好的韩漫平台了！资源超全，更新也快，下拉式阅读体验丝滑到不行。最重要的是完全免费，良心平台！',
      date: '2026-07-28',
    },
    {
      name: '追漫达人小王',
      avatar: 'https://readdy.ai/api/search-image?query=A%20young%20professional%20man%20avatar%20portrait%2C%20confident%20smile%2C%20modern%20casual%20style%2C%20clean%20cream%20background%2C%20simple%20digital%20illustration%20portrait&width=120&height=120&seq=avatar-02&orientation=squarish',
      rating: 5,
      comment: '每天必刷妖精漫画，分类特别清晰，找漫画超方便。天命之子和暗影猎人这两部真的太上头了，推荐给所有喜欢热血漫画的朋友！',
      date: '2026-07-25',
    },
    {
      name: '漫画评论员阿林',
      avatar: 'https://readdy.ai/api/search-image?query=A%20young%20woman%20with%20glasses%20avatar%20portrait%2C%20intellectual%20and%20warm%20expression%2C%20artsy%20style%2C%20clean%20cream%20background%2C%20simple%20digital%20illustration%20portrait&width=120&height=120&seq=avatar-03&orientation=squarish',
      rating: 5,
      comment: '作为资深漫画评论人，我对平台的要求很高。妖精漫画的排版和阅读体验真的做到了极致，下拉式设计非常符合韩漫的阅读习惯。',
      date: '2026-07-20',
    },
    {
      name: '学生党小李',
      avatar: 'https://readdy.ai/api/search-image?query=A%20young%20female%20student%20avatar%20portrait%2C%20bright%20and%20cheerful%20expression%2C%20casual%20youth%20style%2C%20clean%20cream%20background%2C%20simple%20digital%20illustration%20portrait&width=120&height=120&seq=avatar-04&orientation=squarish',
      rating: 4,
      comment: '超级棒的平台！免费的韩漫资源太全了，而且没有广告打扰。恋爱漫画区是我的最爱，甜蜜圈纪看了三遍都不腻！',
      date: '2026-07-18',
    },
    {
      name: '夜猫子读者',
      avatar: 'https://readdy.ai/api/search-image?query=A%20young%20man%20avatar%20portrait%2C%20cool%20and%20relaxed%20vibe%2C%20night%20owl%20style%2C%20clean%20cream%20background%2C%20simple%20digital%20illustration%20portrait&width=120&height=120&seq=avatar-05&orientation=squarish',
      rating: 5,
      comment: '深夜追漫的最佳伴侣！迷失之城和血月之花这两部悬疑漫画太刺激了，每晚必看，根本停不下来。妖精漫画，永远的神！',
      date: '2026-07-15',
    },
    {
      name: '韩漫老粉',
      avatar: 'https://readdy.ai/api/search-image?query=A%20mature%20man%20avatar%20portrait%2C%20warm%20and%20experienced%20expression%2C%20classic%20style%2C%20clean%20cream%20background%2C%20simple%20digital%20illustration%20portrait&width=120&height=120&seq=avatar-06&orientation=squarish',
      rating: 5,
      comment: '从2022年就开始用妖精漫画了，一路见证了平台的成长。现在资源越来越丰富，体验越来越好，希望妖精漫画越做越大！',
      date: '2026-07-10',
    },
  ],
  contact: {
    email: 'contact@yaojingmanhua.com',
    weibo: '@妖精漫画官方',
    wechat: '妖精漫画官方号',
    qqGroup: '892156734',
    address: '广东省广州市天河区体育西路111号',
    phone: '020-8888-6666',
  },
  faq: [
    {
      question: '妖精漫画真的完全免费吗？',
      answer: '是的！妖精漫画始终坚持免费阅读模式，所有漫画资源均可免费在线观看，无需付费订阅。我们通过广告合作和版权运营来维持平台运转，确保用户享受零门槛的阅读体验。',
    },
    {
      question: '妖精漫画的漫画资源从哪里来？',
      answer: '我们的漫画资源来自与韩国多家漫画工作室及出版社的正版合作授权，同时也有部分为网友自发翻译分享的内容。我们严格遵守版权法规，致力于推动韩漫文化的健康传播。',
    },
    {
      question: '什么是下拉式阅读模式？',
      answer: '下拉式阅读是妖精漫画针对韩国漫画特点优化的阅读方式。不同于传统的翻页模式，您只需向下滑动屏幕即可连续阅读，画面过渡更加自然流畅，完美适配韩漫的长条式画幅特点。',
    },
    {
      question: '如何找到想看的漫画？',
      answer: '您可以通过首页的分类导航按题材浏览漫画，也可以在搜索框中直接搜索漫画名称。我们还提供了热门排行、最新上架等推荐栏目，帮助您发现精彩的漫画作品。',
    },
    {
      question: '妖精漫画支持哪些设备阅读？',
      answer: '妖精漫画完美适配桌面电脑、平板和手机等各类设备。无论是在家用电脑大屏阅读，还是通勤路上用手机追更，都能获得流畅舒适的阅读体验。',
    },
    {
      question: '漫画更新频率是怎样的？',
      answer: '热门连载漫画通常每周更新1-2话，具体更新频率取决于原作方的发布进度。您可以在每部漫画的详情页查看最新的更新时间和章节列表。',
    },
    {
      question: '如何联系妖精漫画团队？',
      answer: '您可以通过以下方式联系我们：发送邮件至 contact@yaojingmanhua.com，关注新浪微博 @妖精漫画官方，或加入官方QQ群 892156734。我们会在24小时内回复您的咨询。',
    },
  ],
};